module.exports = require("es6-promisify");


//////////////////
// WEBPACK FOOTER
// external "es6-promisify"
// module id = 37
// module chunks = 0